import React from "react";
import { useSelector } from "react-redux";
import { Chip, Tooltip } from "@mui/material";
import HealingIcon from "@mui/icons-material/Healing";

/**
 * "Available fix" indicator for CSPM check rows.
 * Request Fix is only available from the resource drawer (failed resources).
 */
const RequestFixButton = ({ checkId, showPill = true }) => {
  const remediable = useSelector((s) => s.remediation?.remediableChecks);
  const isRemediable = Array.isArray(remediable?.ids) && remediable.ids.includes(checkId);

  if (!isRemediable || !showPill) return null;

  return (
    <Tooltip title="One-click remediation is available — open failed resources to request a fix." arrow placement="top">
      <Chip
        size="small"
        icon={<HealingIcon fontSize="small" />}
        label="Available fix"
        sx={{
          backgroundColor: "#e8f5e9",
          color: "#2e7d32",
          fontWeight: 600,
          fontSize: 11,
          height: 22,
          "& .MuiChip-icon": { color: "#2e7d32" },
        }}
      />
    </Tooltip>
  );
};

export default RequestFixButton;
